// De checklist van een taak: afvinken, en (ontwerp Taakbeheer, 23/10/2026) punten toevoegen, hernoemen door erop te
// klikken en weghalen, voor de planner en de eigenaar. De volgorde is die van Planner. Een collega ziet de lijst met
// bolletjes. Gedeeld door de taaklade en de taakpagina.
import { useState, type KeyboardEvent } from "react";
import { Icon } from "../../lib/icons";
import type { Task, TaskOp } from "../../lib/types";
import { newId, type TaskPerm } from "./perm";

const MAX_NAME = 500;

export function ChecklistSection({ task, perm, run, page }: { task: Task; perm: TaskPerm; run: (ops: TaskOp[], message: string) => void; page?: boolean }) {
  const [draft, setDraft] = useState("");
  const [edit, setEdit] = useState<{ id: string; name: string } | null>(null);
  const done = task.checklist.filter((c) => c.done).length, n = task.checklist.length;
  const manage = perm.edit && !task.done;
  if (!n && !manage) return null;
  const add = () => {
    const name = draft.trim();
    if (!name) return;
    setDraft("");
    run([{ kind: "checklist-add", itemId: newId(), name, done: false }], "Punt toegevoegd: " + name);
  };
  const rename = () => {
    if (!edit) return;
    const name = edit.name.trim(), c = task.checklist.find((x) => x.id === edit.id);
    setEdit(null);
    if (c && name && name !== c.name) run([{ kind: "checklist-rename", itemId: c.id, name }], "Punt hernoemd: " + name);
  };
  const onKey = (e: KeyboardEvent<HTMLInputElement>, ok: () => void, cancel: () => void) => {
    if (e.key === "Enter") { e.preventDefault(); ok(); }
    if (e.key === "Escape") { e.preventDefault(); cancel(); }
  };
  const head = n ? "Checklist · " + done + " van " + n : "Checklist";
  return (
    <>
      {page
        ? <div className="p-tk-boxh"><h3>Checklist</h3>{n > 0 && <span className="p-tk-clbar"><span className="bar"><i style={{ width: Math.round((done / n) * 100) + "%" }} /></span>{done} van {n}</span>}</div>
        : <h3>{head}</h3>}
      <div className="p-cl-list">
        {task.checklist.map((c) => (
          <div key={c.id} className={"p-cli" + (c.done ? " done" : "")}>
            {manage
              ? <input type="checkbox" checked={c.done} aria-label={c.name} onChange={() => run([{ kind: "checklist", itemId: c.id, done: !c.done }], (c.done ? "Weer open: " : "Afgevinkt: ") + c.name)} />
              : <i className="p-cli-ro">{c.done && <Icon name="check" size={11} />}</i>}
            {edit?.id === c.id
              ? <input className="ex-input p-cli-in" value={edit.name} maxLength={MAX_NAME} autoFocus aria-label="Punt hernoemen" onChange={(e) => setEdit({ id: c.id, name: e.target.value })} onBlur={rename} onKeyDown={(e) => onKey(e, rename, () => setEdit(null))} />
              : manage
                ? <button type="button" className="p-cli-t" title="Klik om te hernoemen" onClick={() => setEdit({ id: c.id, name: c.name })}>{c.name}</button>
                : <span className="p-cli-t">{c.name}</span>}
            {manage && <button type="button" className="p-cli-x" aria-label="Punt weghalen" title="Weghalen" onClick={() => run([{ kind: "checklist-remove", itemId: c.id }], "Punt weggehaald: " + c.name)}><Icon name="x" size={13} /></button>}
          </div>
        ))}
        {!n && <p className="p-kd-note" style={{ margin: "2px 0 4px" }}>Nog geen punten.</p>}
      </div>
      {manage && (
        <div className="p-cl-add">
          <input className="ex-input" type="text" placeholder="Nieuw punt, Enter voegt toe" aria-label="Nieuw punt" value={draft} maxLength={MAX_NAME} onChange={(e) => setDraft(e.target.value)} onKeyDown={(e) => onKey(e, add, () => setDraft(""))} />
          <button type="button" className="ex-btn-xs" disabled={!draft.trim()} onClick={add}><Icon name="plus" size={13} />Toevoegen</button>
        </div>
      )}
    </>
  );
}
